<template>
  <div style="margin-top: 5rem">
    <h1 class="title">Your Policy Documents</h1>
    <p class="instruction">
      To view or download, please click on the documents below.
    </p>
    <div class="account-documents" v-if="documents && documents.length > 0">
      <div v-for="item in documents" :key="item.url" class="documents">
        <span
          v-if="item.type === 'card'"
          v-on:click="openDocument(item)"
          class="card"
        >
          <b-icon
            pack="fas"
            icon="id-card"
            size="is-large"
            :class="{}"
          ></b-icon>
          <p>ID Card</p>
        </span>
        <span
          v-if="item.type === 'declaration'"
          v-on:click="openDocument(item)"
          class="card"
        >
          <b-icon
            pack="fas"
            icon="file-invoice"
            size="is-large"
            :class="{}"
          ></b-icon>
          <p>Declaration Page</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Docs',
  props: {
    documents: {
      type: Array,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    token: {
      type: String
    }
  },
  methods: {
    openDocument(item) {
      window.open(item.url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.account-documents {
  padding: 2rem 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
p.instruction {
  text-align: center;
}
.documents {
  flex-direction: column;
  display: flex;
  justify-content: center;
}
span.card {
  cursor: pointer;
  color: $black;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  padding: 15px;
  margin: 5px;
  width: 145px;
  border-radius: 15px;
  border: solid 2px $black;

  p {
    margin: 1em 0 0;
  }
}
span.icon {
}
</style>
